<template>
    <Dialog
        :visible="visible"
        header="Justificativa da alteração"
        modal
        class="w-11 md:w-6 lg:w-4"
        @update:visible="!$event && emit('cancelar')"
    >
        <p class="mt-0 mb-3 text-color-secondary text-sm">
            Toda alteração manual em conta fica registrada no histórico junto com o motivo.
        </p>

        <label for="justificativa_alteracao" class="block font-medium mb-2">
            Motivo da alteração <span class="text-red-500">*</span>
        </label>
        <Textarea
            id="justificativa_alteracao"
            v-model="texto"
            class="w-full"
            rows="4"
            autofocus
            :invalid="!!erro"
            aria-describedby="justificativa_alteracao_contador justificativa_alteracao_erro"
        />
        <div class="flex justify-content-between gap-2 mt-1 text-xs">
            <span id="justificativa_alteracao_erro" class="text-red-500" role="alert">{{ erro }}</span>
            <!-- O mínimo vale para o texto sem espaços nas pontas, igual ao servidor. -->
            <span
                id="justificativa_alteracao_contador"
                :class="suficiente ? 'text-color-secondary' : 'justificativa-faltando'"
            >
                {{ tamanho }} / mín. {{ JUSTIFICATIVA_MIN }} caracteres
            </span>
        </div>

        <template #footer>
            <Button
                label="Cancelar"
                severity="secondary"
                icon="pi pi-times"
                size="small"
                @click="emit('cancelar')"
            />
            <Button
                label="Confirmar"
                severity="success"
                icon="pi pi-check"
                size="small"
                :disabled="!suficiente"
                @click="emit('confirmar', texto.trim())"
            />
        </template>
    </Dialog>
</template>

<script setup>
import { computed } from 'vue';
import Dialog from 'primevue/dialog';
import Textarea from 'primevue/textarea';
import Button from 'primevue/button';

import { JUSTIFICATIVA_MIN } from './contaAlteracao.js';

defineProps({
    visible: { type: Boolean, default: false },
    // Mensagem do 422 do servidor, quando ele recusou a justificativa enviada.
    erro: { type: String, default: '' },
});
const emit = defineEmits(['confirmar', 'cancelar']);

// O texto mora no pai: se o salvar falhar por outro motivo, reabrir o
// diálogo traz o que já foi digitado em vez de obrigar a redigitar.
const texto = defineModel('texto', { type: String, default: '' });

const tamanho = computed(() => texto.value.trim().length);
const suficiente = computed(() => tamanho.value >= JUSTIFICATIVA_MIN);
</script>

<style scoped>
.justificativa-faltando {
    color: var(--p-amber-400);
}
</style>
